import { render } from "./GraphInscriptionsPerWeek.vue?vue&type=template&id=f12a9968"
import script from "./GraphInscriptionsPerWeek.vue?vue&type=script&lang=js"
export * from "./GraphInscriptionsPerWeek.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Florian\\Work\\Sportips\\NOUVEAUX MODULES\\inscription\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__